module.exports = __webpack_public_path__ + "images/22d867da0a72afac939342829fce9cf8-logo.png";